import "./RelatedListStyles.scss";
import $ from "jquery";
import { applyHoverZoomEffectWrapper, evenHeights, track_event } from "../FunctionsCore";
const relatedList = (relatedListParameter) => {
    $(() => {
        if (relatedListParameter.adobeAnalyticsEnabled) {
            window.document.querySelectorAll(".partners_exchange_list .related_list a").forEach((el) => {
                el.addEventListener("click", () => track_event("dnb_marketplace_card_link_clicked"));
            });
        }
        $(".related_list").each(function () {
            const $this = $(this);
            evenHeights($this, ".banner");
            evenHeights($this, ".contenttype_area");
            evenHeights($this, ".title");
            evenHeights($this, ".author");
            evenHeights($this, ".description");
            evenHeights($this, ".tagline");
        });
        $(".select_menu_label").on("click", function () {
            $(this).parent().find(".select_menu_dropdown").eq(0).toggleClass("active");
        });
        applyHoverZoomEffectWrapper(relatedListParameter.applyHoverZoomEffectWrapperParameter);
    });
};
export { relatedList };
